import axios from 'axios';
import apiBaseUrl from './config';

const api = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: false,
});

// Attach token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
